/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddHiringTestDto } from '../models/AddHiringTestDto';
import type { ApplyByInviteDto } from '../models/ApplyByInviteDto';
import type { CreateHiringDto } from '../models/CreateHiringDto';
import type { HiringObjectResponseDto } from '../models/HiringObjectResponseDto';
import type { HiringProfilesListResponseDto } from '../models/HiringProfilesListResponseDto';
import type { OkResponseDto } from '../models/OkResponseDto';
import type { SetCandidateStatusDto } from '../models/SetCandidateStatusDto';
import type { UpdateCandidateRoleDto } from '../models/UpdateCandidateRoleDto';
import type { UpdateHiringDto } from '../models/UpdateHiringDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HiringService {
    /**
     * @returns HiringObjectResponseDto Вакансия создана
     * @throws ApiError
     */
    public static hiringControllerCreate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: CreateHiringDto,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns HiringProfilesListResponseDto Список вакансий
     * @throws ApiError
     */
    public static hiringControllerList({
        id,
    }: {
        id: string,
    }): CancelablePromise<HiringProfilesListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/hiring',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Карточка вакансии
     * @throws ApiError
     */
    public static hiringControllerOne({
        id,
        hid,
    }: {
        id: string,
        hid: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/hiring/{hid}',
            path: {
                'id': id,
                'hid': hid,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Вакансия обновлена
     * @throws ApiError
     */
    public static hiringControllerUpdate({
        id,
        hid,
        requestBody,
    }: {
        id: string,
        hid: string,
        requestBody: UpdateHiringDto,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}',
            path: {
                'id': id,
                'hid': hid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns HiringObjectResponseDto Эталон из среднего команды
     * @throws ApiError
     */
    public static hiringControllerUseTeamAverage({
        id,
        hid,
    }: {
        id: string,
        hid: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/use-team-average',
            path: {
                'id': id,
                'hid': hid,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Эталон из топ-перформеров
     * @throws ApiError
     */
    public static hiringControllerUsePerformance({
        id,
        hid,
    }: {
        id: string,
        hid: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/use-performance',
            path: {
                'id': id,
                'hid': hid,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Вакансия клонирована
     * @throws ApiError
     */
    public static hiringControllerClone({
        id,
        hid,
    }: {
        id: string,
        hid: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/clone',
            path: {
                'id': id,
                'hid': hid,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Вакансия опубликована
     * @throws ApiError
     */
    public static hiringControllerPublish({
        id,
        hid,
    }: {
        id: string,
        hid: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/publish',
            path: {
                'id': id,
                'hid': hid,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Срок вакансии продлён
     * @throws ApiError
     */
    public static hiringControllerRenew({
        id,
        hid,
        days,
    }: {
        id: string,
        hid: string,
        days: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/renew',
            path: {
                'id': id,
                'hid': hid,
            },
            query: {
                'days': days,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Матчинг пересчитан
     * @throws ApiError
     */
    public static hiringControllerCompute({
        id,
        hid,
        candidateId,
    }: {
        id: string,
        hid: string,
        candidateId: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/compute-match',
            path: {
                'id': id,
                'hid': hid,
            },
            query: {
                'candidateId': candidateId,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Статус кандидата изменён
     * @throws ApiError
     */
    public static hiringControllerSetCandidateStatus({
        id,
        hid,
        cid,
        requestBody,
    }: {
        id: string,
        hid: string,
        cid: string,
        requestBody: SetCandidateStatusDto,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/candidates/{cid}/status',
            path: {
                'id': id,
                'hid': hid,
                'cid': cid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkResponseDto Кандидат принят в команду
     * @throws ApiError
     */
    public static hiringControllerMoveToTeam({
        id,
        hid,
        cid,
        requestBody,
    }: {
        id: string,
        hid: string,
        cid: string,
        requestBody: UpdateCandidateRoleDto,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/candidates/{cid}/move-to-team',
            path: {
                'id': id,
                'hid': hid,
                'cid': cid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkResponseDto Кандидат удалён
     * @throws ApiError
     */
    public static hiringControllerRemoveCandidate({
        id,
        hid,
        cid,
    }: {
        id: string,
        hid: string,
        cid: string,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/companies/{id}/hiring/{hid}/candidates/{cid}',
            path: {
                'id': id,
                'hid': hid,
                'cid': cid,
            },
        });
    }
    /**
     * @returns OkResponseDto Профиль команды обновлён
     * @throws ApiError
     */
    public static hiringControllerRefreshTeamProfile({
        id,
        tid,
    }: {
        id: string,
        tid: string,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/teams/{tid}/refresh-team-profile',
            path: {
                'id': id,
                'tid': tid,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Заявка по инвайту
     * @throws ApiError
     */
    public static hiringControllerApplyByInvite({
        requestBody,
    }: {
        requestBody: ApplyByInviteDto,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/invite/apply',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns HiringObjectResponseDto Тесты вакансии
     * @throws ApiError
     */
    public static hiringControllerListTests({
        id,
        hid,
    }: {
        id: string,
        hid: string,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/hiring/{hid}/tests',
            path: {
                'id': id,
                'hid': hid,
            },
        });
    }
    /**
     * @returns HiringObjectResponseDto Тест добавлен к вакансии
     * @throws ApiError
     */
    public static hiringControllerAddTest({
        id,
        hid,
        requestBody,
    }: {
        id: string,
        hid: string,
        requestBody: AddHiringTestDto,
    }): CancelablePromise<HiringObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/hiring/{hid}/tests',
            path: {
                'id': id,
                'hid': hid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkResponseDto Тест удалён
     * @throws ApiError
     */
    public static hiringControllerRemoveTest({
        id,
        hid,
        testId,
    }: {
        id: string,
        hid: string,
        testId: string,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/companies/{id}/hiring/{hid}/tests/{testId}',
            path: {
                'id': id,
                'hid': hid,
                'testId': testId,
            },
        });
    }
}
